import { defineComponent as _defineComponent } from 'vue'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import HighestFireOutbreakMarker from './HighestFireOutbreakMarker.vue'
import FireOutbreakMarker from './FireOutbreakMarker.vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import FireOutbreakTooltip from './FireOutbreakTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFireOutbreakMarker',
  props: {
    alert: null
  },
  setup(__props: any) {



function getMarkerContainer(tippyInstance: any): HTMLElement | null {
	return tippyInstance.reference?.closest('.mapboxgl-marker') ?? null
}

const tooltipOptions = {
	trigger: 'click',
	onShow(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = '10'
	},
	onHide(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = ''
	},
}

return { __sfc: true,getMarkerContainer, tooltipOptions, HighestFireOutbreakMarker, FireOutbreakMarker, Tooltip, FireOutbreakTooltip }
}

})